import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { FieldRequestParameters, GroupByRequestParameters, RequestParameters } from '../../shared/models/request-parameters/parameter.model';
import { GlobalVariable } from '../../global';
import { UserClk } from './user-clk.model';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { DatePipe } from '@angular/common';

@Injectable()
export class UsersClkService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getUsersClk(parameters: RequestParameters = new RequestParameters()) {
    console.log(parameters);
    const params = this.normalizeReportParameters(parameters);
    return this.http.get(GlobalVariable.BASE_API_URL + '/operators/clk', {
      params: params.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  getUserClk(reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/operator/clk/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      );

  }

  postUserClk(userClk: UserClk) {

    const body = this.normalizeUserClkData(userClk);

    return this.http.post(GlobalVariable.BASE_API_URL + '/operators/clk', body)
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }

  putUserClk(userClk: UserClk) {

    const body = this.normalizeUserClkData(userClk);

    return this.http.put(GlobalVariable.BASE_API_URL + '/operator/clk/' + userClk.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  patchUserClk(userClk: UserClk) {

    const body = this.normalizeUserClkData(userClk);

    return this.http.patch(GlobalVariable.BASE_API_URL + '/operator/clk/' + userClk.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );

  }

  deleteUserClk(userClk: UserClk) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/operator/clk/' + userClk.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status
          });
        }
      );
  }
  disableUserClk(userClk: UserClk, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/operator/' + userClk.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch((error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status
        });
      }
      );
  }
  private normalizeUserClkData(userPartner: UserClk): UserClk {

    const body = Object.assign({}, userPartner);
    delete body.reference;

    if (body.picture !== null) {
      body.picture = body.picture.reference;
    }
    if (body.country !== null) {
      body.country = body.country.reference;
    }
    if (body.city !== null) {
      body.city = body.city.reference;
    }
    if (body.callCenter !== null) {
      body.callCenter = body.callCenter.reference;
    }
    if (body.role !== null) {
      body.role = body.role.reference;
    }
    if (body.platform !== null) {
      body.platform = body.platform.reference;
    }
    return body;
  }

  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  normalizeReportParameters(parameters: any): RequestParameters {
    console.log(parameters);
    let requestParameters = new RequestParameters();

    requestParameters.limit = (parameters.limit !== undefined && parameters.limit !== null) ? parameters.limit : -1;
    requestParameters.offset = (parameters.offset !== undefined && parameters.offset !== null) ? parameters.offset : 0;

    if (parameters.fields) {
      if (Array.isArray(parameters.fields)) {
        parameters.fields.forEach(f => {
          if (f.field === 'callCenter') {
            const reqCallCenterParameter = new FieldRequestParameters('callCenter', f.value);
            requestParameters.fields.push(reqCallCenterParameter);
          } else if (f.field === 'operationDate') {
            requestParameters.fields.push(f);
          }
        });
      } else {
        if (parameters.fields.operationDate !== null && parameters.fields.operationDate !== undefined) {
          const datePipe = new DatePipe('en');
          const dates = parameters.fields.operationDate;
          const date1 = datePipe.transform(dates.value, 'yyyy-MM-ddT00:00:00');
          const date2 = datePipe.transform(dates.value2, 'yyyy-MM-ddT23:59:59');
          const reqDateParameter = new FieldRequestParameters('operationDate', null, date1, date2);
          requestParameters.fields.push(reqDateParameter);
        }
        if (parameters.fields.callCenter !== undefined && parameters.fields.callCenter !== null) {
          const callCenterRef = parameters.fields.callCenter.reference ? parameters.fields.callCenter.reference : parameters.fields.callCenter;
          const reqCallCenterParameter = new FieldRequestParameters(
            'callCenter',
            callCenterRef
          );
          requestParameters.fields.push(reqCallCenterParameter);
        }
      }
    }

    if (parameters.searchString !== undefined && parameters.searchString !== null && parameters.searchString !== '') {
      requestParameters.searchString = parameters.searchString;
    }

    return requestParameters;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users-clk/users-clk.service.ts